import { gql } from "@apollo/client";

export const PRODUCT_RANGES = gql`
  query ProductRanges(
    $where: ProductRangeWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    productRanges(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      data {
        id
        code
        label
        ownedBy {
          id
        }
      }
      count
    }
  }
`;

export const PRODUCT_RANGE = gql`
  query ProductRange($where: ProductRangeWhereInput) {
    productRange(where: $where) {
      id
      code
      label
      ownedBy {
        id
      }
    }
  }
`;

export const ADVISOR_PRODUCT_SELLER_CODES = gql`
  query AdvisorProductSellerCodes(
    $where: AdvisorProductSellerCodeWhereInput
    $take: Int
    $skip: Int
    $orderBy: [JSONObject]
  ) {
    advisorProductSellerCodes(
      where: $where
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      data {
        id
        sellerCode
        hasApiPassword
        user {
          id
          firstname
          lastname
          meta
        }
        productRange {
          id
          code
          label
        }
      }
      count
    }
  }
`;

const productRangeAdvisorCodesQueries = {
  PRODUCT_RANGES,
  PRODUCT_RANGE,
  ADVISOR_PRODUCT_SELLER_CODES,
};

export default productRangeAdvisorCodesQueries;
